/* global process */
import PropTypes from 'prop-types'
import React from 'react'
import ReactGA from 'react-ga'
import hotkeys from 'hotkeys-js'
import { Router } from 'react-router'
import { connect } from 'react-redux'

import Header from 'components/Header'
import Breadcrumbs from 'components/Elements/Breadcrumbs'
import { Footer } from 'components/Footer'
import SessionActions from 'actions/session'
import BrowsingActions from 'actions/browsing'
import GuideViewer from 'components/GuideViewer/Viewer'
import FeedbackCreator from 'components/Feedback/FeedbackCreator'
import ConnectionStatusBar from 'components/Elements/ConnectionStatusBar'
import WipperForm from 'components/WipperSnapper/Form'
import SystemMessages from 'components/Elements/SystemMessages';
import { Spinner } from 'components/Elements/Loading'
import log from 'utils/logger' // eslint-disable-line

import 'stylesheets/application.scss'

class Root extends React.Component {
  constructor(props) {
    super(props)

    this.removeKiosk = this.removeKiosk.bind(this)

    this.state = {
      showKioskNotification: true
    }

    ReactGA.initialize('UA-7723544-1')
  }

  componentDidMount() {
    this.props.dispatch(SessionActions.initializeSession())
  }

  componentDidUpdate(prevProps) {
    if (this.props.kiosk && !prevProps.kiosk) {
      hotkeys('esc', this.removeKiosk)
    }
  }

  componentWillUnmount() {
    hotkeys.unbind('esc', this.removeKiosk)
  }

  removeKiosk() {
    this.props.dispatch(BrowsingActions.browsingSetKiosk(false))
    hotkeys.unbind('esc', this.removeKiosk)
  }

  logPageView() {
    let isDNT = navigator.doNotTrack === "yes" || navigator.doNotTrack === "1" ||
                window.doNotTrack === "1"

    if (process.env.NODE_ENV === 'production' && !isDNT) {
      ReactGA.set({ page: window.location.pathname , origin: "io-ui"})
      ReactGA.pageview(window.location.pathname)
    }
  }

  content() {
    if (this.props.loading) {
      return  (
         <div className="container">
           <div className="row">
             <div className="col-md-12">
               <div className='root-loading'>
                 <Spinner />
               </div>
             </div>
           </div>
         </div>
      )
    } else if (this.props.ready) {
      // don't start Router until session has finished loading
      const { history, routes } = this.props
      return <Router history={history} routes={routes} onUpdate={this.logPageView} />
    } else {
      return <div className='error'>Failed to initialize session!</div>
    }
  }

  render () {
    if (this.props.kiosk) {
      return (
        <>
          <div className="kiosk-wrapper">
            {this.content()}
          </div>
        </>
      )
    }

    return (
      <>
        <div id="outer-wrapper">
          <div id="inner-wrapper">
            <Header />
            <ConnectionStatusBar />
            <main id="main-content">
              { this.props.user &&
                <WipperForm />
              }
              <SystemMessages />
              <Breadcrumbs />
              <GuideViewer />
              <FeedbackCreator id="root" />
              {this.content()}
              <div id="main-content-overlay" />
            </main>
            <Footer />
          </div>
        </div>
      </>
    )
  }
}

Root.propTypes = {
  // set by libraries
  history: PropTypes.object.isRequired,
  routes: PropTypes.element.isRequired,
  dispatch: PropTypes.func.isRequired,

  // set by our code
  client: PropTypes.object,
  user: PropTypes.object,
  loading: PropTypes.bool
}

const mapStateToProps = (state) => {
  return {
    loading: state.session.loading,
    ready: state.session.ready,
    user: state.session.user,
    kiosk: state.browsing.kiosk,
    client: state.session.client
  }
}

export default connect(mapStateToProps)(Root)
